module.exports = __webpack_public_path__ + "static/media/Sem_nome_1170_275_px_1000_275_px.417eb541.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/cyberseguranca/Sem_nome_1170_275_px_1000_275_px.png
// module id = 288
// module chunks = 0